/* ============================================================
   TTP header behaviour
   - Mobile drawer (open/close, esc, overlay, focus return)
   - Touch/keyboard support for nav dropdowns
   - Live open/closed status (America/New_York), Mon-Fri
   - Cart subtotal mirror (watches #cart-icon-bubble re-renders)
   - window.ttpOpenChat() -> Zendesk widget, with graceful fallback
   ============================================================ */
(function () {
  'use strict';

  var header = document.querySelector('.ttp-header');
  if (!header) return;

  /* ---------- Mobile drawer ---------- */
  var drawer = document.getElementById('ttp-drawer');
  var overlay = document.getElementById('ttp-drawer-overlay');
  var openBtn = header.querySelector('.js-ttp-drawer-open');
  var lastFocus = null;

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    if (overlay) overlay.classList.toggle('is-open', open);
    document.body.classList.toggle('ttp-drawer-open', open);
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      lastFocus = document.activeElement;
      var first = drawer.querySelector('a, button, input');
      if (first) first.focus();
    } else if (lastFocus) {
      lastFocus.focus();
    }
  }

  if (openBtn && drawer) {
    openBtn.addEventListener('click', function () { setDrawer(true); });
    drawer.querySelectorAll('.js-ttp-drawer-close').forEach(function (btn) {
      btn.addEventListener('click', function () { setDrawer(false); });
    });
    if (overlay) overlay.addEventListener('click', function () { setDrawer(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setDrawer(false);
    });
  }

  /* ---------- Dropdowns: caret buttons toggle, outside click closes ---------- */
  header.querySelectorAll('.js-ttp-subtoggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var li = btn.closest('li');
      var wasOpen = li.classList.contains('is-open');
      var scope = li.closest('ul');
      if (scope) {
        scope.querySelectorAll(':scope > li.is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var t = o.querySelector('.js-ttp-subtoggle');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
      li.classList.toggle('is-open', !wasOpen);
      btn.setAttribute('aria-expanded', String(!wasOpen));
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.ttp-nav, .ttp-brands')) {
      header.querySelectorAll('.ttp-nav li.is-open, .ttp-brands li.is-open').forEach(function (li) {
        li.classList.remove('is-open');
        var t = li.querySelector('.js-ttp-subtoggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ---------- Open/closed status engine (shared with product page) ---------- */
  function etParts() {
    var p = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour12: false,
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    }).formatToParts(new Date());
    var o = {};
    p.forEach(function (x) { o[x.type] = x.value; });
    return {
      day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(o.weekday),
      mins: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10),
      secs: parseInt(o.second, 10)
    };
  }

  function fmt12(mins) {
    var h = Math.floor(mins / 60);
    var m = mins % 60;
    var ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    return h12 + (m ? ':' + String(m).padStart(2, '0') : ':00') + ' ' + ap;
  }

  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  // Business days: Mon(1)-Fri(5). Returns {open, text} for status elements.
  function ttpStatus(openMins, closeMins) {
    var now = etParts();
    var isBizDay = now.day >= 1 && now.day <= 5;
    if (isBizDay && now.mins >= openMins && now.mins < closeMins) {
      return { open: true, text: 'Open for business — until ' + fmt12(closeMins) + ' ET' };
    }
    var d = now.day;
    if (isBizDay && now.mins < openMins) {
      return { open: false, text: 'Closed — opens today ' + fmt12(openMins) + ' ET' };
    }
    do { d = (d + 1) % 7; } while (d < 1 || d > 5);
    var label = (d === (now.day + 1) % 7) ? 'tomorrow' : DAY_NAMES[d];
    return { open: false, text: 'Closed — opens ' + label + ' ' + fmt12(openMins) + ' ET' };
  }

  window.ttpStatus = ttpStatus;
  window.ttpEtParts = etParts;
  window.ttpFmt12 = fmt12;
  window.ttpDayNames = DAY_NAMES;

  function refreshStatus() {
    document.querySelectorAll('[data-ttp-status]').forEach(function (el) {
      var open = parseInt(el.getAttribute('data-open-mins'), 10);
      var close = parseInt(el.getAttribute('data-close-mins'), 10);
      if (isNaN(open) || isNaN(close)) return;
      var s = ttpStatus(open, close);
      el.setAttribute('data-state', s.open ? 'open' : 'closed');
      var txt = el.querySelector('[data-ttp-status-text]');
      if (txt) txt.textContent = s.text;
      var chip = el.querySelector('[data-ttp-status-chip]');
      if (chip) chip.textContent = s.open ? el.getAttribute('data-open-label') || 'OPEN NOW' : el.getAttribute('data-closed-label') || 'CLOSED';
    });
    document.querySelectorAll('[data-ttp-dot]').forEach(function (el) {
      var open = parseInt(el.getAttribute('data-open-mins'), 10);
      var close = parseInt(el.getAttribute('data-close-mins'), 10);
      if (isNaN(open) || isNaN(close)) return;
      el.setAttribute('data-state', ttpStatus(open, close).open ? 'open' : 'closed');
    });
  }
  refreshStatus();
  setInterval(refreshStatus, 30000);

  /* ---------- Cart subtotal mirror ---------- */
  var moneyEl = header.querySelector('[data-ttp-cart-total]');
  var bubble = document.getElementById('cart-icon-bubble');

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withComma = parts.join('.');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma.replace(/,/g, '#').replace('.', ',').replace(/#/g, '.'));
  }

  function refreshCartTotal() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (moneyEl) {
          moneyEl.innerHTML = formatMoney(cart.total_price, moneyEl.getAttribute('data-money-format'));
        }
        document.querySelectorAll('[data-ttp-cart-count]').forEach(function (el) {
          el.hidden = cart.item_count === 0;
          var num = el.querySelector('.header__cart-count-number');
          if (num) num.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  if ((moneyEl || document.querySelector('[data-ttp-cart-count]')) && bubble && 'MutationObserver' in window) {
    new MutationObserver(function () { refreshCartTotal(); }).observe(bubble, { childList: true, subtree: true });
  }
  document.addEventListener('on:cart:add', refreshCartTotal);
  document.addEventListener('dispatch:cart-drawer:refresh', refreshCartTotal);

  /* Mobile cart icon: open the theme cart drawer (falls back to /cart without JS) */
  header.querySelectorAll('.js-ttp-cart-open').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    });
  });

  /* ---------- Chat opener (Zendesk web widget / messenger), with fallback ---------- */
  window.ttpOpenChat = function (fallbackUrl) {
    try {
      if (typeof window.zE === 'function') {
        try { window.zE('messenger', 'open'); return true; } catch (e1) { /* classic widget below */ }
        try { window.zE('webWidget', 'open'); return true; } catch (e2) { /* fall through */ }
        try { window.zE.activate(); return true; } catch (e3) { /* fall through */ }
      }
      if (window.$zopim && window.$zopim.livechat) { window.$zopim.livechat.window.show(); return true; }
    } catch (e) { /* fall through */ }
    if (fallbackUrl) window.location.href = fallbackUrl;
    return false;
  };
  document.querySelectorAll('.js-ttp-chat').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.ttpOpenChat(btn.getAttribute('data-fallback') || btn.getAttribute('href'));
    });
  });

  /* ---------- --header-height safety for theme scripts ---------- */
  function setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
}());
